import { useQuery, UseQueryOptions } from 'react-query';
import type { UserData } from './types';
import { fetchCurrentUserByEventId } from './api';

export const useCurrentUser = (eventId: number | null, options?: UseQueryOptions<UserData>) => {
    const enabled = !!eventId && options?.enabled && options.enabled;
    return useQuery<UserData, Error>('currentUser', () => fetchCurrentUserByEventId(eventId), {
        ...options,
        enabled,
    });
};
